(() => {
  const moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
  }

  function init(section) {
    const items = Array.from(section.querySelectorAll('[data-slcsb-item]'));
    const addButton = section.querySelector('[data-slcsb-add]');
    const selectedCountEl = section.querySelector('[data-slcsb-selected-count]');
    const totalEl = section.querySelector('[data-slcsb-total]');
    const compareEl = section.querySelector('[data-slcsb-compare-total]');
    const saveEl = section.querySelector('[data-slcsb-save]');
    const stickyTotalEl = section.querySelector('[data-slcsb-total-sticky]');
    const feedbackEl = section.querySelector('[data-slcsb-feedback]');
    const selectAllBtn = section.querySelector('[data-slcsb-select-all]');
    const clearBtn = section.querySelector('[data-slcsb-clear]');
    const addStickyButton = section.querySelector('[data-slcsb-add-sticky]');

    if (!items.length || !addButton || !selectedCountEl || !totalEl) {
      return;
    }

    const setFeedback = (message, type) => {
      if (!feedbackEl) return;
      feedbackEl.classList.remove('is-success', 'is-error');
      if (!message) {
        feedbackEl.textContent = '';
        return;
      }
      feedbackEl.textContent = message;
      feedbackEl.classList.add(type === 'error' ? 'is-error' : 'is-success');
    };

    const getActiveRows = () => {
      return items.filter((row) => {
        const checkbox = row.querySelector('[data-slcsb-checkbox]');
        return checkbox && checkbox.checked && !checkbox.disabled;
      });
    };

    const parseInteger = (value) => {
      if (value === undefined || value === null || String(value).trim() === '') return null;
      const number = Number(value);
      return Number.isInteger(number) ? number : null;
    };

    let lastCalculatedTotal = null;

    const getSelectionState = () => {
      const rows = getActiveRows();
      const lines = rows.map((row) => {
        const variantSelect = row.querySelector('[data-slcsb-variant]');
        const selectedOption = variantSelect ? variantSelect.selectedOptions[0] : null;
        const qtyInput = row.querySelector('[data-slcsb-qty]');
        const id = parseInteger(selectedOption ? selectedOption.value : row.dataset.variantId);
        const qty = parseInteger(qtyInput ? qtyInput.value : '1');
        const price = parseInteger(selectedOption ? selectedOption.dataset.price : row.dataset.price);
        const compareAt = parseInteger(selectedOption ? selectedOption.dataset.compareAt : row.dataset.compareAt);
        const invalid =
          row.dataset.parentVariantMismatch === 'true' ||
          !id || id < 1 ||
          qty === null || qty < 1 ||
          price === null || price < 0 ||
          compareAt === null || compareAt < 0 ||
          (selectedOption && selectedOption.disabled);
        return { row, id, qty, price, compareAt, invalid };
      });
      const valid = lines.every((line) => !line.invalid);
      const total = valid ? lines.reduce((sum, line) => sum + line.price * line.qty, 0) : null;
      const compareTotal = valid
        ? lines.reduce((sum, line) => sum + Math.max(line.compareAt, line.price) * line.qty, 0)
        : null;
      return { rows, lines, valid, total, compareTotal };
    };

    const updateTotals = () => {
      const state = getSelectionState();
      const { rows, lines, valid, total, compareTotal } = state;
      selectedCountEl.textContent = String(rows.length);

      if (!valid) {
        lastCalculatedTotal = null;
        totalEl.textContent = '—';
        if (stickyTotalEl) stickyTotalEl.textContent = '—';
        document.querySelectorAll('[data-slx-price], [data-sl-sticky-price], [data-slx-klarna-amount]').forEach((el) => {
          el.textContent = '—';
        });
        if (compareEl) {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
        if (saveEl) {
          saveEl.textContent = '';
          saveEl.style.display = 'none';
        }
        addButton.disabled = true;
        if (addStickyButton) addStickyButton.disabled = true;
        setFeedback(section.dataset.errorText || 'Setgegevens onvolledig. Toevoegen is tijdelijk uitgeschakeld.', 'error');
        return;
      }

      lastCalculatedTotal = total;
      lines.forEach(({ row, qty, price, compareAt }) => {
        const itemPriceCurrent = row.querySelector('[data-slcsb-item-price]');
        const itemPriceCompare = row.querySelector('[data-slcsb-item-compare]');
        if (itemPriceCurrent) itemPriceCurrent.textContent = formatMoney(price * qty);
        if (itemPriceCompare) {
          if (compareAt > price) {
            itemPriceCompare.textContent = formatMoney(compareAt * qty);
            itemPriceCompare.style.display = '';
          } else {
            itemPriceCompare.textContent = '';
            itemPriceCompare.style.display = 'none';
          }
        }
      });

      totalEl.textContent = formatMoney(total);
      document.querySelectorAll('[data-slx-price], [data-sl-sticky-price]').forEach((el) => {
        el.textContent = formatMoney(total);
      });
      document.querySelectorAll('[data-slx-compare-price], [data-slx-save-badge]').forEach((el) => {
        el.style.display = 'none';
      });
      document.querySelectorAll('[data-slx-klarna-amount]').forEach((el) => {
        el.textContent = formatMoney(Math.round(total / 4));
      });
      const plateRow = rows.find((row) => row.hasAttribute('data-slcsb-drukplaat-row'));
      const plateSelect = plateRow && plateRow.querySelector('[data-slcsb-plate-select]');
      const plateOption = plateSelect && plateSelect.selectedOptions[0];
      document.querySelectorAll('[data-sl-set-plate-description]').forEach((el) => {
        el.textContent = plateOption ? plateOption.dataset.label : 'Geen drukplaat geselecteerd';
      });

      if (stickyTotalEl) stickyTotalEl.textContent = formatMoney(total);
      if (compareEl && saveEl) {
        if (compareTotal > total) {
          compareEl.textContent = formatMoney(compareTotal);
          compareEl.style.display = '';
          saveEl.textContent = `Besparing: ${formatMoney(compareTotal - total)}`;
          saveEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
          saveEl.textContent = '';
          saveEl.style.display = 'none';
        }
      }

      const canAdd = rows.length > 0;
      addButton.disabled = !canAdd;
      if (addStickyButton) addStickyButton.disabled = !canAdd;
      setFeedback('', 'success');
    };

    const collectItemsPayload = () => {
      const state = getSelectionState();
      if (!state.valid || !state.rows.length || state.total !== lastCalculatedTotal) return null;
      const payload = state.lines.map(({ id, qty }) => ({ id, quantity: qty }));
      if (payload.length !== state.rows.length || payload.some((item) => !item.id || item.quantity < 1)) return null;
      return { payload, total: state.total };
    };

    if (section.dataset.productId === '15666829852996') {
      document.addEventListener('sl:variant:change', (event) => {
        const title = String(event.detail && event.detail.variant && event.detail.variant.title || '').toLowerCase();
        const parentVariant = title.includes('chroom') ? 'chrome' : 'white';
        const plateRow = section.querySelector('[data-slcsb-drukplaat-row]');
        const plateSelect = plateRow && plateRow.querySelector('[data-slcsb-plate-select]');
        if (!plateRow || !plateSelect) return;
        const matchingOption = Array.from(plateSelect.options).find((option) => option.dataset.parentVariant === parentVariant && !option.disabled);
        if (!matchingOption) {
          plateRow.dataset.parentVariantMismatch = 'true';
          updateTotals();
          return;
        }
        plateRow.dataset.parentVariantMismatch = 'false';
        plateSelect.value = matchingOption.value;
        plateSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    items.forEach((row) => {
      row.addEventListener('change', (event) => {
        if (event.target.matches('[data-slcsb-checkbox], [data-slcsb-variant], [data-slcsb-qty]')) {
          updateTotals();
        }
      });
    });

    if (selectAllBtn) {
      selectAllBtn.addEventListener('click', () => {
        items.forEach((row) => {
          const checkbox = row.querySelector('[data-slcsb-checkbox]');
          if (checkbox && !checkbox.disabled) checkbox.checked = true;
        });
        updateTotals();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        items.forEach((row) => {
          const checkbox = row.querySelector('[data-slcsb-checkbox]');
          if (checkbox && !checkbox.disabled) checkbox.checked = false;
        });
        updateTotals();
      });
    }

    const handleAddToCart = async () => {
      const selection = collectItemsPayload();
      if (!selection) {
        updateTotals();
        if (!getActiveRows().length) {
          setFeedback('Selecteer minimaal een product.', 'error');
        } else {
          setFeedback(section.dataset.errorText || 'Setgegevens onvolledig. Toevoegen is tijdelijk uitgeschakeld.', 'error');
        }
        return;
      }
      const payload = selection.payload;

      setFeedback('', 'success');
      addButton.disabled = true;
      if (addStickyButton) {
        addStickyButton.disabled = true;
      }
      const originalText = addButton.textContent;
      const originalStickyText = addStickyButton ? addStickyButton.textContent : '';
      const loadingText = section.dataset.loadingText || 'Bezig met toevoegen...';
      addButton.textContent = loadingText;
      if (addStickyButton) {
        addStickyButton.textContent = loadingText;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: payload })
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        setFeedback(section.dataset.successText || 'De setproducten zijn toegevoegd aan je winkelwagen.', 'success');
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // Open the cart drawer
        const drawer = document.getElementById('Cart-Drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        }
      } catch (error) {
        setFeedback(section.dataset.errorText || 'Producten konden niet worden toegevoegd. Probeer het opnieuw.', 'error');
      } finally {
        addButton.textContent = originalText;
        if (addStickyButton) {
          addStickyButton.textContent = originalStickyText;
        }
        updateTotals();
      }
    };

    addButton.addEventListener('click', handleAddToCart);
    if (addStickyButton) {
      addStickyButton.addEventListener('click', handleAddToCart);
    }

    updateTotals();
  }

  const sections = document.querySelectorAll('[data-slcsb-section]');
  sections.forEach(init);
})();


(() => {
  const productCache = new Map();

  function imageUrl(src, width) {
    if (!src) return '';
    const separator = src.includes('?') ? '&' : '?';
    return src + separator + 'width=' + width;
  }

  async function getProduct(url) {
    const cleanUrl = url.split('?')[0].replace(/\/$/, '');
    if (!productCache.has(cleanUrl)) {
      productCache.set(cleanUrl, fetch(cleanUrl + '.js', {
        headers: { Accept: 'application/json' }
      }).then((response) => {
        if (!response.ok) throw new Error('Productgegevens konden niet worden geladen');
        return response.json();
      }));
    }
    return productCache.get(cleanUrl);
  }

  async function updateItemImage(row, select) {
    const link = row.querySelector('.slcsb-item__title a');
    const image = row.querySelector('.slcsb-item__media img');
    if (!link || !image || !select.value) return;

    try {
      const product = await getProduct(link.href);
      const variant = product.variants.find((item) => String(item.id) === String(select.value));
      const source = variant && variant.featured_image && variant.featured_image.src
        ? variant.featured_image.src
        : (product.images && product.images[select.selectedIndex] ? product.images[select.selectedIndex] : product.featured_image);

      if (!source) return;
      image.srcset = '';
      image.src = imageUrl(source, 220);
      image.alt = product.title + (variant && variant.title !== 'Default Title' ? ' – ' + variant.title : '');

      const meta = row.querySelector('.slcsb-item__meta span');
      if (meta && variant && variant.title !== 'Default Title') {
        meta.textContent = variant.title;
      }
    } catch (_) {
      return;
    }
  }

  function initBuilder(root) {
    root.addEventListener('change', (event) => {
      const select = event.target.closest('[data-slcsb-variant]');
      if (!select) return;
      const row = select.closest('[data-slcsb-item]');
      if (row && !row.hasAttribute('data-slcsb-drukplaat-row')) updateItemImage(row, select);
    });
  }

  function initJumpButton(button) {
    const label = button.querySelector('span');
    if (label) label.textContent = 'Bekijk kleuren';
    button.setAttribute('aria-label', 'Bekijk kleuren');

    button.addEventListener('click', () => {
      const target = document.querySelector('[data-slcsb-section]');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      target.classList.remove('slcsb--color-focus');
      window.requestAnimationFrame(() => target.classList.add('slcsb--color-focus'));
      const heading = target.querySelector('.slcsb__title');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        window.setTimeout(() => heading.focus({ preventScroll: true }), 450);
      }
      window.setTimeout(() => target.classList.remove('slcsb--color-focus'), 1800);
    });
  }

  function init() {
    document.querySelectorAll('[data-slcsb-section]').forEach(initBuilder);
    document.querySelectorAll('[data-slx-set-jump]').forEach(initJumpButton);

    if (!document.getElementById('sl-set-colors-sync-style')) {
      const style = document.createElement('style');
      style.id = 'sl-set-colors-sync-style';
      style.textContent = '.slcsb--color-focus{animation:slcsb-color-focus 1.8s ease}@keyframes slcsb-color-focus{0%,100%{box-shadow:none}25%,70%{box-shadow:inset 0 0 0 3px #b6884a}}@media(prefers-reduced-motion:reduce){.slcsb--color-focus{animation:none;box-shadow:inset 0 0 0 3px #b6884a}}';
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

(() => {
  const styleId = 'sl-set-colour-button-styles';

  function initColourButtons() {
    document.querySelectorAll('[data-slx-set-jump]').forEach((button) => {
      if (button.dataset.slColourStateReady === 'true') return;
      button.dataset.slColourStateReady = 'true';
      button.addEventListener('click', () => {
        button.classList.add('is-clicked');
      });
    });

    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      [data-slx-set-jump] {
        background: #5f5364 !important;
        border-color: #5f5364 !important;
        color: #fff !important;
        transition: background-color .2s ease, border-color .2s ease;
      }
      [data-slx-set-jump]:hover,
      [data-slx-set-jump]:focus-visible {
        background: #514657 !important;
        border-color: #514657 !important;
        color: #fff !important;
      }
      [data-slx-set-jump].is-clicked,
      [data-slx-set-jump]:active {
        background: #d97732 !important;
        border-color: #d97732 !important;
        color: #fff !important;
      }
    `;
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColourButtons, { once: true });
  } else {
    initColourButtons();
  }
  document.addEventListener('shopify:section:load', initColourButtons);
})();

